import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  disableCloudWatchRum,
  initCloudWatchRum,
  trackCloudWatchRumPageVisit,
} from '../../cloudwatch-rum'
import { useTrackingConsent } from '../../utils/trackingConsent'

import { useAPIGetCloudwatchRumConfig } from 'api/apiHooks/useAPIGetCloudwatchRumConfig'
import { useAPIGetUserProfile } from 'api/apiHooks/useAPIGetUserProfile'

export const CloudWatchRumInitializer = () => {
  const location = useLocation()
  const hasTrackingConsent = useTrackingConsent()
  const { data: config } = useAPIGetCloudwatchRumConfig()
  const { data: userProfile } = useAPIGetUserProfile()

  useEffect(() => {
    if (!hasTrackingConsent) {
      disableCloudWatchRum()
      return
    }
    if (!config || !userProfile) return
    initCloudWatchRum(config, userProfile.uuid)
  }, [hasTrackingConsent, config, userProfile])

  useEffect(() => {
    trackCloudWatchRumPageVisit(
      `${location.pathname}${location.search}${location.hash}`
    )
  }, [location])

  return null
}
